import { Section } from '../UI/IgmtInk'
import FaceMask from '../../assets/FaceMask-min.png'
import FaceMaskWebp from '../../assets/FaceMask.webp'
import HandSanitizer from '../../assets/HandSanitizer-min.png'
import HandSanitizerWebp from '../../assets/HandSanitizer.webp'
import NoSmoking from '../../assets/NoSmoking-min.png'
import NoSmokingWebp from '../../assets/NoSmoking.webp'
import NoKissing from '../../assets/NoKissing-min.png'
import NoKissingWebp from '../../assets/NoKissing.webp'

const HealthProtocol = props => {
  return (
    <Section
      attr={{ id: 'healthProtocol' }}
      className="p-9 lg:py-24 bg-[#f9f9f9] animate-slide-down"
    >
      <h2 className='mb-8 md:mb-14 lg:mb-16 text-center text-4xl md:text-6xl font-["Courgette"] text-blue-500 font-bold'>
        Health Protocol
      </h2>

      <div className="grid grid-auto-fit-sm gap-4">
        <div className="grid grid-cols-1 gap-4 justify-items-center items-center bg-blue-500 p-4 rounded-md shadow-md">
          <picture>
            <source srcSet={FaceMaskWebp} type="image/webp" />
            <source srcSet={FaceMask} type="image/png" />

            <img
              className="w-1/3 sm:w-1/2 mx-auto"
              src={FaceMaskWebp}
              alt="Wearing Masks"
            />
          </picture>
          <div className="grid grid-cols-1 gap-2">
            <span className="text-lg font-bold text-center">Wear Masks</span>
            <p className="text-center">
              Encourage all guests to wear masks to reduce the risk of
              transmission.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 justify-items-center items-center bg-blue-500 p-4 rounded-md shadow-md">
          <picture>
            <source srcSet={HandSanitizerWebp} type="image/webp" />
            <source srcSet={HandSanitizer} type="image/png" />

            <img
              className="w-1/3 sm:w-1/2 mx-auto"
              src={HandSanitizerWebp}
              alt="Hand Sanitizer"
            />
          </picture>
          <div className="grid grid-cols-1 gap-2">
            <span className="text-lg font-bold text-center">
              Sanitize your Hands
            </span>
            <p className="text-center">
              Encourage to wash your hands frequently and to use hand sanitizer.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 justify-items-center items-center bg-blue-500 p-4 rounded-md shadow-md">
          <picture>
            <source srcSet={NoSmokingWebp} type="image/webp" />
            <source srcSet={NoSmoking} type="image/png" />

            <img
              className="w-1/3 sm:w-1/2 mx-auto"
              src={NoSmokingWebp}
              alt="No Smoking"
            />
          </picture>
          <div className="grid grid-cols-1 gap-2">
            <span className="text-lg font-bold text-center">No Smoking</span>
            <p className="text-center">
              Go to the place somewhere that have a smoking area.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 justify-items-center items-center bg-blue-500 p-4 rounded-md shadow-md">
          <picture>
            <source srcSet={NoKissingWebp} type="image/webp" />
            <source srcSet={NoKissing} type="image/png" />

            <img
              className="w-1/3 sm:w-1/2 mx-auto"
              src={NoKissingWebp}
              alt="No Kissing"
            />
          </picture>
          <div className="grid grid-cols-1 gap-2">
            <span className="text-lg font-bold text-center">
              No Kissing to the Baby
            </span>
            <p className="text-center">
              Avoid activities that involve close physical contact, such as
              hugging or kissing.
            </p>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default HealthProtocol
